module.exports = __webpack_public_path__ + "static/img/strona_032.df27d6ec.jpg";